// Import Libraries
import React from 'react';

// -----------------------------------------------------------
//  ProductDisabledOptionsMessage
// -----------------------------------------------------------
const ProductDisabledOptionsMessage = ({
  disabledOptions,
  className,
  children,
  dataTestId,
}) => {
  if (disabledOptions.length) {
    return (
      <div className={className} data-test-id={dataTestId}>
        <p className="m-0">
          {disabledOptions.length === 1
            ? 'Product option is unavailable: '
            : 'Product options are unavailable: '}
          please choose {disabledOptions.length === 1 && 'a'} different{' '}
          {disabledOptions.join(', ')} before checkout.&nbsp;
          {children}
        </p>
      </div>
    );
  }

  return null;
};

export default ProductDisabledOptionsMessage;
